export const LINGERS_LOCAL_STORAGE_KEY = 'raychat_lingers'
export const OLD_USER_ID_KEY = 'rayToken'
export const DATA_OBJECT_KEY = 'www.raychat.io'
